import Utils from "../../../utility";

const initialState = {
  advertisementList: [],
  order: "DESC",
  offset: 1,
  take: 20,
  count: 0,
  adPurchaseList: [],
  adPurchaseCount: 0,
  adPurchaseOffset: 1,
  adPurchaseTake: 20,
};

export const advertisementReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.ADVERTISEMENT}`:
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
};
